export default function getWindow() {
  return window;
}